import React, { Component } from 'react';
import '../../resources/css/settings/DateFilter.scss';

class DateFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preset: 'custom',
      fromDate: '',
      toDate: '',
      selectedColumn: 'createdDate'
    };
  }

  getDateColumns = () => {
    const { componentName } = this.props;
    
    const baseColumns = [
      { value: 'createdDate', label: 'Created Date' },
      { value: 'lastUpdatedDate', label: 'Last Updated' }
    ];
    
    const accountColumns = [
      { value: 'lastLoginDate', label: 'Last Login' }
    ];
    
    return componentName === 'AccountSettingsList' ? [...baseColumns, ...accountColumns] : baseColumns;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.preset !== this.state.preset) {
      this.updateDatesByPreset();
    }
  }

  updateDatesByPreset = () => {
    const { preset } = this.state;
    const today = new Date();
    let from, to;
    
    switch (preset) {
      case 'day':
        from = new Date(today.setHours(0,0,0,0));
        to = new Date();
        break;
      case 'week': {
        to = new Date();
        from = new Date();
        from.setDate(to.getDate() - 7); 
        break;
      }
      case 'month': {
        to = new Date();
        from = new Date();
        from.setMonth(from.getMonth() - 1); 
        break;
      }
      case 'custom':
        return;
      default:
        return;
    }
    
    const isoFrom = from.toISOString().split('T')[0];
    const isoTo = to.toISOString().split('T')[0];
    this.setState({
      fromDate: isoFrom,
      toDate: isoTo
    });
  }

  handlePresetChange = (e) => {
    this.setState({ preset: e.target.value });
  }

  handleFromDateChange = (e) => {
    this.setState({ 
      preset: 'custom',
      fromDate: e.target.value 
    });
  }

  handleToDateChange = (e) => {
    this.setState({ 
      preset: 'custom',
      toDate: e.target.value 
    });
  }

  handleColumnChange = (e) => {
    this.setState({ selectedColumn: e.target.value });
  }

  handleApply = () => {
    const { fromDate, toDate, selectedColumn } = this.state;
    const { onApply, openModalAlert } = this.props;
    
    if (!fromDate || !toDate) {
      openModalAlert('Please select both dates');
      return;
    }
    
    onApply({ 
      from: fromDate, 
      to: toDate,
      column: selectedColumn 
    });
  }

  handleClear = () => {
    const { onApply } = this.props;
    
    this.setState({
      preset: 'custom',
      fromDate: '',
      toDate: ''
    });
    
    onApply({ from: null, to: null, column: null });
  }

  render() {
    const { preset, fromDate, toDate, selectedColumn } = this.state;
    const dateColumns = this.getDateColumns();
    
    return (
      <div className="date-filter-container compact">
        <div className="filter-group">
          <label>Filter By</label>
          <select 
            value={selectedColumn} 
            onChange={this.handleColumnChange}
          >
            {dateColumns.map(column => (
              <option key={column.value} value={column.value}>
                {column.label}
              </option>
            ))}
          </select>
        </div>
        <div className="filter-group">
          <label>Date</label>
          <select value={preset} onChange={this.handlePresetChange}>
            <option value="day">Today</option>
            <option value="week">Last 7 Days</option>
            <option value="month">Last 30 Days</option>
            <option value="custom">Custom</option>
          </select>
        </div>
        <div className="filter-group">
          <label>From</label>
          <input 
            type="date" 
            value={fromDate} 
            onChange={this.handleFromDateChange} 
          />
        </div>
        <div className="filter-group">
          <label>To</label>
          <input 
            type="date" 
            value={toDate} 
            onChange={this.handleToDateChange} 
          />
        </div>
        <div className="button-group">
          <button onClick={this.handleApply} className="apply-button">Apply</button>
          <button onClick={this.handleClear} className="clear-button">Clear</button>
        </div>
      </div>
    );
  }
}

export default DateFilter; 